import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { type PrimitiveProps } from 'reka-ui';
    import { cva, type VariantProps } from 'class-variance-authority';

    export type IndicatorVariants = VariantProps<typeof indicatorVariants>;

    interface Props extends PrimitiveProps {
        variant?: IndicatorVariants['variant'];
        size?: IndicatorVariants['size'];
        class?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Indicator',
  props: {
    variant: {},
    size: {},
    class: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props: any) {

    const indicatorVariants = cva(
        'inline-flex items-center justify-center rounded-full transition-all shrink-0 outline-none',
        {
            variants: {
                variant: {
                    default: 'bg-destructive',
                    red: 'bg-destructive',
                    green: 'bg-accent',
                    yellow: 'bg-warning',
                    bright_yellow: 'bg-warning',
                    blue: 'bg-primary',
                    baby_blue: 'bg-primary',
                    transparent: 'bg-transparent border border-foreground',
                },
                size: {
                    default: 'size-3',
                    sm: 'size-2',
                    lg: 'size-4',
                },
            },
            defaultVariants: {
                variant: 'default',
                size: 'default',
            },
        },
    );

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(cn)(_unref(indicatorVariants)({ variant: _ctx.variant, size: _ctx.size }), props.class))
  }, null, 2))
}
}

})